import { useEffect, useState } from 'react';

const CheckIconAnimated = () => {
  const [drawn, setDrawn] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => requestAnimationFrame(() => setDrawn(true)));
  }, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="24"
      height="24"
    >
      <path
        d="M4 12l5 5L20 6"
        style={{
          strokeDasharray: 100,
          strokeDashoffset: drawn ? 0 : 100,
          transition: 'stroke-dashoffset 0.8s ease-in-out',
        }}
      />
    </svg>
  );
};

export default CheckIconAnimated;
